<div class="mapping-step">
  <p class="mapping-step__hint">
    {{ 'knowledge_base.import.mapping.hint' | translate }}
  </p>

  <!-- One select per FIELD, listing the columns of the file. The operator
       knows their file has a price; they were being asked to classify every
       column into a vocabulary of ours. -->
  <div class="mapping-step__fields">
    <div
      class="mapping-step__field"
      *ngFor="let role of roles; trackBy: trackByRole"
      [class.is-clashing]="isDuplicated(role)"
    >
      <span class="mapping-step__field-label">
        {{ roleLabelKey(role) | translate }}
        <span class="mapping-step__required" *ngIf="isRequired(role)" aria-hidden="true">*</span>
      </span>
      <mat-select
        class="mapping-step__column"
        [value]="columnOf[role] ?? null"
        (valueChange)="setColumn(role, $event)"
        [placeholder]="'knowledge_base.import.mapping.no_column' | translate"
      >
        <mat-option [value]="null">
          {{ 'knowledge_base.import.mapping.no_column' | translate }}
        </mat-option>
        <mat-option *ngFor="let column of columns; trackBy: trackByIndex" [value]="column.index">
          {{ column.label }}
        </mat-option>
      </mat-select>
    </div>
  </div>

  <!-- The live sample: the consequence of the select just moved, on the
       operator's own rows, before anything is created. It shows the mapped
       columns only — the table IS the reading. -->
  <div class="mapping-step__sample" *ngIf="sampleSize && sampleColumns.length">
    <div class="mapping-step__sample-head">
      <span class="mapping-step__sample-title">
        {{ 'knowledge_base.import.mapping.preview_title' | translate }}
      </span>
      <!-- Only when a customer column is named: without one the count has
           nothing to count, and the audience of the drop step applies to
           every row instead. -->
      <span class="mapping-step__sample-counter" *ngIf="hasCustomerColumn">
        {{
          'knowledge_base.import.mapping.resolved_counter'
            | translate: { resolved: resolvedCustomerCount, total: sampleSize }
        }}
      </span>
      <span class="mapping-step__sample-counter" *ngIf="!hasCustomerColumn">
        {{ 'knowledge_base.import.mapping.no_customer_column' | translate }}
      </span>
    </div>

    <div class="mapping-step__sample-scroll">
      <table class="mapping-step__sample-table">
        <thead>
          <tr>
            <th *ngFor="let column of sampleColumns; trackBy: trackByIndex">
              {{ roleLabelKey(column.role) | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of sampleRows; trackBy: trackByIndex">
            <td *ngFor="let cell of row.cells">{{ cell }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="mapping-step__actions">
    <p class="mapping-step__blocked" *ngIf="blockedReasonKey">
      {{ blockedReasonKey | translate: blockedReasonParams }}
    </p>
    <ui-button
      type="secondary"
      [label]="'knowledge_base.import.back' | translate"
      (click)="cancel()"
    ></ui-button>
    <ui-button
      type="primary"
      [label]="'knowledge_base.import.mapping.confirm' | translate"
      [disabled]="!canConfirm"
      (click)="confirm()"
    ></ui-button>
  </div>
</div>
